import { buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { SparklesIcon } from "lucide-react"

interface TitoAvatarProps {
  className?: string
  iconClassName?: string
}

export default function TitoAvatar({ className, iconClassName }: TitoAvatarProps) {
  return (
    <div
      className={cn(
        buttonVariants({
          size: "icon",
        }),
        "size-8 rounded-full bg-gradient-to-br from-primary-100 via-primary-400 to-primary-700 max-[425px]:size-11",
        "backdrop-blur-[62.22px]",
        className,
      )}
    >
      <SparklesIcon className={cn("!size-5 !text-white/80", iconClassName)} />
      <span className="sr-only">Tito</span>
    </div>
  )
}
